export default "__VITE_ASSET__9e6J$Ug5__"